import React from 'react'
import styled from 'styled-components'
import Pane from 'components/Common/Pane'
import PaneBody from 'components/Common/Pane/PaneBody'
import Icon from '../Icon'
import Heading from 'LuxKit/Typography/Heading'
import BodyText from 'LuxKit/Typography/BodyText'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'

const Root = styled(Pane)`
  border: 1px solid ${props => props.theme.palette.neutral.default.five};
  border-radius: ${props => props.theme.borderRadius.M};
`

const CenteredPaneBody = styled(PaneBody)`
  text-align: center;
`

interface Props {
  title: string
  text: string
  icon: string
}

function KeyMessageTile(props: Props) {
  const { title, text, icon } = props

  return (
    <Root>
      <CenteredPaneBody size="lg xl-y" mobileSize="md lg-y">
        <VerticalSpacer gap={20}>
          <Icon name={icon} type="primary" size={40} />
          <VerticalSpacer gap={8}>
            <Heading variant="heading6">
              {title}
            </Heading>
            <BodyText variant="large">
              {text}
            </BodyText>
          </VerticalSpacer>
        </VerticalSpacer>
      </CenteredPaneBody>
    </Root>
  )
}

export default KeyMessageTile
